<template>

    <v-progress-circular indeterminate :size="size" :width="width" color="pink"></v-progress-circular>

</template>

<script>
  export default {
    props: {
      size: {
        default: 70
      },

      width: {
        default: 5
      }
    }
  };
</script>


// WEBPACK FOOTER //
// src/components/Loader.vue